import { createAjaxAction, AjaxResponse } from '../../Common/_actions/AjaxAction';
import { createAction } from '../../Common/_actions/Action';
import { Toast, SetOrderingStatus } from '../..//UIData/_actions/UIDataActions';
import { Dispatch } from "redux";

export type CartAddressType = "shipping" | "billing";

export enum UserCartActionType {
	EditCart = "CART_EDIT",
};

let cartActionSuccess = (response: AjaxResponse, dispatch: Dispatch) => {
	if(response.data.success && response.data.cart) {
		dispatch(EditCart(response.data.cart));
	} else dispatch(Toast('Something went wrong!'));
}

let cartActionFailure = (response: AjaxResponse, dispatch: Dispatch) => {
	if(response && response.data && response.data.error)
		dispatch(Toast(response.data.error));
	else
		dispatch(Toast('Something went wrong!'));
}

export const GetUserCart = () => createAjaxAction({
	url: "ajax/cart/get-user-cart",
	method: "GET",
	onSuccess: cartActionSuccess,
	onFailure: cartActionFailure,
});

export const SaveCartAddress = (data: FormData) => createAjaxAction({
	url: "ajax/cart/save-cart-address",
	method: "POST",
	data: data,
	onSuccess: cartActionSuccess,
	onFailure: cartActionFailure,
});

export const DeleteCartItem = (data: FormData) => createAjaxAction({
	url: "ajax/cart/delete-cart-item",
	method: "POST",
	limit: 100,
	data: data,
	onSuccess: cartActionSuccess,
	onFailure: cartActionFailure,
});

export const UpdateCartItem = (data: FormData) => createAjaxAction({
	url: "ajax/cart/update-cart-item",
	method: "POST",
	limit: 300,
	data: data,
	onSuccess:  (response: AjaxResponse, dispatch: Dispatch) => {
		if(response.data.success && response.data.cart && !data.get('id')) {
			dispatch(Toast("Fabric added to cart"));
		};
		dispatch(SetOrderingStatus(false));
		cartActionSuccess(response, dispatch);
	},
	onFailure: cartActionFailure,
});

export const UpdateCartShippingType = (data: FormData) => createAjaxAction({
	url: "ajax/cart/update-cart-shipping-type",
	method: "POST",
	limit: 300,
	data: data,
	onSuccess: cartActionSuccess,
	onFailure: cartActionFailure,
});

export const EditCart = (cart: any) => createAction(UserCartActionType.EditCart, {
	cart: cart
});

export type UserCartAction =
	ReturnType<typeof EditCart>